import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { ReactComponent as LeftArrow } from '../../../../src/assets/images/angle-left-svgrepo-com.svg';
import { ReactComponent as RightArrow } from '../../../../src/assets/images/angle-right-svgrepo-com.svg';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import styles from './Swiper.module.scss';
import { formatDate, isSelectedDay } from './utils/utils';

SwiperCore.use([Navigation, Pagination]);

interface SwiperProps {
    dates: string[];
    showAllSessions?: boolean;
    onDayClick: (item: any) => void;
}

const SwiperControl = ({ dates, showAllSessions, onDayClick }: SwiperProps) => {
    const { selectedDay } = useSelector((state: any) => state.current_user);
    const swiperRef = useRef<any>(null);

    useEffect(() => {
        if (selectedDay) {
            scrollToSlide(selectedDay);
        }
    }, [selectedDay]);

    const scrollToSlide = (date: string) => {
        const index = dates.findIndex((slide) => slide == date);
        if (index !== -1 && swiperRef.current) {
            swiperRef.current.swiper.slideTo(index);
        }
    };

    return (
        <div className={styles.swiper}>
            <button className={styles.prev}>
                <LeftArrow />
            </button>
            <Swiper
                ref={swiperRef}
                spaceBetween={1}
                slidesPerView={'auto'}
                keyboard={{ enabled: true }}
                modules={[Pagination, Navigation]}
                navigation={{
                    nextEl: `.${styles.next}`,
                    prevEl: `.${styles.prev}`,
                }}
            >
                {dates && dates.map((day, index) => {
                    const { day: formattedDay, month, weekday } = formatDate(day);
                    const selectedClass = !showAllSessions && isSelectedDay(day, selectedDay) ? styles.selectedDay : '';
                    const labelClass = !showAllSessions && isSelectedDay(day, selectedDay) ? styles.selectedDayLabel : '';

                    return (
                        <SwiperSlide
                            key={index}
                            className={`${styles.day} ${selectedClass}`}
                            onClick={() => onDayClick(day)}
                        >
                            <div className={labelClass}>
                                {formattedDay}
                            </div>
                            <div className={labelClass}>
                                {month}
                            </div>
                            <div className={`${styles.dayLabel} ${labelClass}`}>
                                {weekday}
                            </div>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
            <button className={styles.next}>
                <RightArrow />
            </button>
        </div>
    );
};

export default SwiperControl;